import { createAction, PayloadAction } from '@reduxjs/toolkit'
import { createReduxActionDefinition } from 'app/state/action'
import { ApiError, RequestStatus } from 'features/common'
import { ProviderType } from 'features/connections'
import { DuplicateMapProps, DuplicateMapType } from '../types'
import { setDryRunDuplicateMapStatus, setDuplicateMapError } from './mapsSlice'

export const name = 'maps'
export interface DuplicateMapState {
  duplicatingMapId: string | null
  duplicateMapType: DuplicateMapType | null
  unavailableConnections: { name: string; providerId: ProviderType }[]
  dryRunDuplicateMapStatus: RequestStatus
  duplicateMapStatus: RequestStatus
  duplicateMapError: ApiError | null
}

export const duplicateInitialState: DuplicateMapState = {
  duplicatingMapId: null,
  unavailableConnections: [],
  dryRunDuplicateMapStatus: RequestStatus.Idle,
  duplicateMapStatus: RequestStatus.Idle,
  duplicateMapError: null,
  duplicateMapType: null
}

export const DRY_RUN_DUPLICATE_MAP_ACTION = `${name}/dry_run_duplicate_map`
export const DUPLICATE_MAP_ACTION = `${name}/duplicate_map`

const asyncActions = {
  dryRunDuplicateMapAction: createAction<DuplicateMapProps>(DRY_RUN_DUPLICATE_MAP_ACTION),
  duplicateMapAction: createAction<DuplicateMapProps>(DUPLICATE_MAP_ACTION)
}
export const duplicateMapsReducers = {
  setDuplicateMapType: (state: DuplicateMapState, action: PayloadAction<DuplicateMapType>) => {
    state.duplicateMapType = action.payload
  },
  setUnavailableConnections: (
    state: DuplicateMapState,
    action: PayloadAction<{ name: string; providerId: ProviderType }[]>
  ) => {
    state.unavailableConnections = action.payload
  },
  setDuplicatingMapId: (state: DuplicateMapState, action: PayloadAction<string | null>) => {
    state.duplicatingMapId = action.payload
  },
  setDuplicateMapStatus: (state: DuplicateMapState, action: PayloadAction<RequestStatus>) => {
    state.duplicateMapStatus = action.payload
  },
  setDryRunDuplicateMapStatus: (state: DuplicateMapState, action: PayloadAction<RequestStatus>) => {
    state.dryRunDuplicateMapStatus = action.payload
  },
  setDuplicateMapError: (state: DuplicateMapState, action: PayloadAction<ApiError | null>) => {
    state.duplicateMapError = action.payload
  }
}

export const dryRunDuplicateMapActionDefinition = createReduxActionDefinition<string>(
  (dispatch, mapId) => {
    dispatch(dryRunDuplicateMapAction({ mapId }))
  },
  {
    status: (state) => state.maps.dryRunDuplicateMapStatus,
    error: (state) => state.maps.duplicateMapError,
    dismissResult: (dispatch) => {
      dispatch(setDryRunDuplicateMapStatus(RequestStatus.Idle))
      dispatch(setDuplicateMapError(null))
    }
  }
)

export const { dryRunDuplicateMapAction, duplicateMapAction } = asyncActions
